import {Component, Input} from '@angular/core';
import {ContentType} from '../../model/asset/Asset';

@Component({
  selector: 'media-playback',
  templateUrl: './media-playback.component.html',
  styleUrls: ['./media-playback.component.scss']
})
export class MediaPlaybackComponent {

  readonly AUDIO_TYPE = ContentType.mp3;
  readonly VIDEO_TYPE = ContentType.mp4;

  @Input() audioUrl?: string;
  @Input() videoUrl?: string;

  constructor() {
  }

}
